<div class="appBottomMenu" >                 
    <a (click)="openPage('/home')" class="item" [class]="(routerName == '/home' || routerName == '/home/'+deviceId) ? 'active' : ''" style="padding-top: 10px !important;">
        <div class="col"> 
            <div style="padding-top: 5px !important;">
                <img [src]="(routerName=='/home' || routerName=='/home/'+deviceId) ?'assets/img/home/activeHome.png':'assets/img/home/inactiveHome.png'" *ngIf="(routerName=='/home' || routerName=='/home/'+deviceId) ?'img-active': 'img-inactive'" alt=" " width="25px">
               
                <br>
                <span><h6 [class]="(routerName=='/home' || routerName=='/home/'+deviceId) ?'active-title': 'inactive-title'">{{ 'homeTap' | translate}}</h6></span>
            </div>
        </div>
    </a>
    <a (click)="openPage('/wallet')" class="item" [class]="(routerName == '/wallet') ? 'active' : ''" *ngIf="isUserLoggedIn" style="padding-top: 10px !important;">
        <div class="col">
            <div style="padding-top: 5px !important;">
                <img [src]="routerName=='/wallet'?'assets/img/home/activewallet.png':'assets/img/home/inactivewallet.png'" alt=" " width="25px"><br>
                <span><h6 [class]="routerName=='/wallet' ?'active-title': 'inactive-title'">{{ 'walletTap' | translate}}</h6></span>
            </div>
        </div>
    </a>
    <a (click)="openPage('/promotion')" class="item"  [class]="(routerName == '/promotion/list') ? 'active' : ''" *ngIf="isUserLoggedIn" style="padding-top: 10px !important;">
        <div class="col">
            <div style="padding-top: 5px !important;">
                <img [src]="routerName == '/promotion/list' ? 'assets/img/home/activepromotion.png' : 'assets/img/home/inactivepromotion.png'" alt=" " width="25px"><br>
                <span><h6 [class]="routerName == '/promotion/list'? 'active-title' : 'inactive-title'">{{ 'promotionTap' | translate}}</h6></span>
            </div>
        </div>
    </a>
    <a (click)="openPage('/service-phone')" class="item" [class]="(routerName=='/service-phone') ? 'active' : ''"  style="padding-top: 10px !important;">
        <div class="col px-0">
            <div style="padding-top: 5px !important;">
                <img [src]="routerName=='/service-phone'?'assets/img/home/activeservice.png':'assets/img/home/inactiveservice.png'" alt=" " width="25px"><br>
                <span><h6 [class]="routerName=='/service-phone'?'active-title': 'inactive-title'">{{ 'serviceTap' | translate}}</h6></span>

            </div>
        </div>
    </a>
    <a (click)="openPage('/profile/me');" class="item" [class]="(routerName =='/profile/me') ? 'active' : ''" style="padding-top: 10px !important;">
        <div class="col">
            <div style="padding-top: 5px !important;">
                <img [src]="routerName=='/profile/me' ? 'assets/img/home/activeme.png' : 'assets/img/home/inactiveme.png'" alt=" " width="25px"><br>
                <span><h6 [class]="routerName == '/profile/me' ? 'active-title' : 'inactive-title'">{{ 'meTap' | translate}}</h6></span>
            </div>
        </div>
    </a>
</div>
       

